<template>
  <div>
    <el-row class="table-grid-content">
      <!-- <el-col :span="3">
        <el-input placeholder="请输入搜索内容"></el-input>
      </el-col>
      <el-col :span="3" class="grid" :gutter="1" style="margin-left: 1rem;">
        <el-button type="success" icon="el-icon-search">搜索</el-button>
      </el-col> -->
      <el-col :span="2" class="grid" :gutter="15" style="margin-left: 2rem">
        <el-button type="primary" @click="addCoursewareShow">增加</el-button>
      </el-col>
    </el-row>
    <el-dialog
        title="访问次数"
        :visible.sync="visitshow"
        width="70%"
        >
        <el-form ref="form" label-width="80px">
            <el-row class="table-grid-content">
                <el-date-picker
                        v-model="visitDate"
                        type="date"
                        placeholder="选择日期"
                        @change="changevisitDate"
                        >
                    </el-date-picker>
                <!-- <el-col :span="3" class="grid" :gutter="1" style="margin-left: 1rem;">
                    <el-button type="success" icon="el-icon-search">搜索</el-button>
                </el-col> -->
            </el-row>
        </el-form>
        <el-table border :data="visitList" style="width: 100%;margin-top: 1rem;">
            <el-table-column label="登陆时间" prop="sfm"></el-table-column>
        </el-table>
        <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="this.visitshow = false">取 消</el-button>
            <el-button type="primary" @click="numberVisit">确 定</el-button>
        </span> -->
        </el-dialog>
    <el-dialog
        title="增加"
        :visible.sync="addcoursewareShow"
        width="70%"
        >
        <el-form ref="form" label-width="80px">
            <el-form-item label="用户名">
                <el-input v-model="form.username"></el-input>
            </el-form-item>
            <el-form-item label="密码">
                <el-input v-model="form.password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码">
                <el-input v-model="form.password2"></el-input>
            </el-form-item>
            <el-form-item label="到期时间">
                <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期时间" v-model="form.expireTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="秘钥">
                <el-input v-model="form.machCode"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="addcoursewareShow = false">取 消</el-button>
            <el-button type="primary" @click="addconfirmCourseware">确 定</el-button>
        </span>
        </el-dialog>
        <el-dialog
        title="编辑"
        :visible.sync="editcoursewareShow"
        width="70%"
        >
        <el-form ref="form" label-width="80px">
            <el-form-item label="用户名">
                <el-input v-model="editform.username"></el-input>
            </el-form-item>
            <el-form-item label="密码">
                <el-input v-model="editform.password"></el-input>
            </el-form-item>
            <el-form-item label="到期时间">
                <el-date-picker
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期时间" v-model="editform.expireTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="秘钥">
                <el-input v-model="editform.machCode"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editcoursewareShow = false">取 消</el-button>
            <el-button type="primary" @click="editconfirmCourseware">确 定</el-button>
        </span>
        </el-dialog>
    <el-table border :data="coursewareList" style="width: 100%;margin-top: 1rem;">
      <el-table-column label="账号" prop="username"></el-table-column>
      <!-- <el-table-column label="密码" prop="password"></el-table-column> -->
      <el-table-column label="唯一标识" prop="mach_code"></el-table-column>
      <el-table-column label="注册时间" prop="create_time"></el-table-column>
      <el-table-column label="到期时间" prop="expire_time"></el-table-column>
      <!-- <el-table-column label="总访问次数" prop="all_count"></el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="editCoursewareShow(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="deleteCourseware(scope.row.id)">删除</el-button>
          <i class="el-icon-view" style="margin-left:10px;cursor:pointer;" @click="visitShow(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>


    <el-pagination
      @current-change="changecoursewareNum"
      :page-size="pageSize"
      :current-page="currentPage"
      layout="total,  prev, pager, next"
      :total="coursewareTotal">
    </el-pagination>
<!-- coursewareSize -->


  </div>
</template>

<script>
import Fingerprint2 from 'fingerprintjs2'
export default {
    data(){
        return{
            addcoursewareShow:false,
            editcoursewareShow:false,
            visitshow: false,
            form:{
                username:'',
                password:'',
                password2:'',
                expireTime:'',
                machCode:''
            },
            editform:{
                id:'',
                username:'',
                password:'',
                expireTime:'',
                machCode:''
            },
            type:'',
            apiUrl:'',
            currentPage:1,
            pageSize:4,
            coursewareList:[],
            visitId:'',
            currentTime:'',
            visitList:[],
            visitDate:'',
            coursewareTotal:0
        }
    },
    created(){
        this.apiUrl = localStorage.aipUrl
        // this.createFingerprint()
        this.getcoursewareList()
         let date = new Date()
            let year = date.getFullYear()
            let month = date.getMonth()+1
            let dates = date.getDate()
            if(month < 10){
                month = '0' + month
            }
            if(dates < 10){
                dates = '0' + dates
            }
            this.visitDate = year + '-' + month + '-' + dates
            console.log(year + '-' + month + '-' + dates)
    },
    methods:{
        // createFingerprint() {
        //     // 浏览器指纹
        //     const fingerprint = Fingerprint2.get((components) => {
        //         // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
        //         const values = components.map((component) => component.value) // 配置的值的数组
        //         const murmur = Fingerprint2.x64hash128(values.join(''), 31) // 生成浏览器指纹
        //         // console.log(components, values,murmur,'你好')
        //         //murmur就是浏览器指纹啦
        //         this.murmur = murmur
        //         console.log(murmur)
        //     })
        // },
        changevisitDate(){
            // console.log(this.visitDate,'aaa')
            let year = this.visitDate.getFullYear()
            let month = this.visitDate.getMonth()+1
            let dates = this.visitDate.getDate()
            if(month < 10){
                month = '0' + month
            }
            if(dates < 10){
                dates = '0' + dates
            }
             console.log(year + '-' + month + '-' + dates)
             this.visitDate = year + '-' + month + '-' + dates
             this.getvisitList()
             console.log(this.visitDate,'this.visitDate')
        },
        visitShow(row){
            this.visitId = row.id
            this.visitshow = true
            this.getvisitList()
        },
        getvisitList(){

            this.axios({
                method:'post',
                url:`${this.apiUrl}/api/v1/pri/user/selectLoginTimeById`,
                data: {
                    "id": this.visitId,
                    "nyr" : this.visitDate
                },
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': sessionStorage.getItem("token")
                }
            }).then(res=>{
                console.log(res.data.data)
                this.visitList = res.data.data

            })
        },
        //查询数据
        getcoursewareList(){
            this.axios({
                method:'post',
                url:`${this.apiUrl}/api/v1/pri/user/selectUser`,
                data: {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize
                },
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': sessionStorage.getItem("token")
                }
            }).then(res=>{
                console.log(res)
                this.coursewareList = res.data.data.list
                this.coursewareTotal = res.data.data.total
                console.log(this.coursewareTotal,this.coursewareSize,this.coursewareNum)
            })
        },
        addconfirmCourseware(){
                //增加
                console.log(this.form.machCode,'add')
                this.axios({
                    method:'post',
                    url:`${this.apiUrl}/api/v1/pri/user/register`,
                    data:this.form,
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'Authorization': sessionStorage.getItem("token")
                    }
                }).then(res=>{
                    console.log(res)
                    if(res.data.stateCode != 200){
                        this.$message.error(`${res.data.msg}`)
                    }else{
                        this.$message.success(`${res.data.msg}`)
                        this.getcoursewareList()
                        this.addcoursewareShow = false
                    }

                })
        },
        editconfirmCourseware(){
            //修改
                this.axios({
                    method:'post',
                    url:`${this.apiUrl}/api/v1/pri/user/updateUserById`,
                    data:this.editform,
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'Authorization': sessionStorage.getItem("token")
                    }
                }).then(res=>{
                    console.log(res)
                    if(res.data.stateCode != 200){
                        this.$message.error('修改失败')
                    }else{
                        this.$message.success('修改成功')
                        this.getcoursewareList()
                        this.editcoursewareShow = false
                    }
                })
                console.log('edit1')
        },
        addCoursewareShow(){
            this.form.username = ''
                this.form.password = ''
                this.form.password2 = ''
                this.form.machCode = ''
                this.form.expireTime = ''
                this.addcoursewareShow = true
        },
        editCoursewareShow(row){
               this.editform.id = row.id
               this.editform.username = row.username
               this.editform.password = row.password
               this.editform.machCode = row.mach_code
               this.editform.expireTime = row.expire_time
               this.editcoursewareShow = true

        },
        deleteCourseware(id){
            this.axios({
                    method:'post',
                    url:`${this.apiUrl}/api/v1/pri/user/deleteUserById`,
                    data:{
                        id:id
                    },
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'Authorization': sessionStorage.getItem("token")
                    }
                }).then(res=>{
                    this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        if(res.data.stateCode != 200){
                            this.$message.error('删除失败')
                        }else{
                            this.$message.success('删除成功')
                            this.getcoursewareList()
                            this.coursewareShow = false
                        }

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });

                })
        },
        changecoursewareNum(pagenum){
            console.log(pagenum)
            this.currentPage = pagenum
            this.getcoursewareList()
        }
    }
}
</script>
<style scoped>

.el-table /deep/ th {
  background-color: #EEEFF1;
}

</style>



// WEBPACK FOOTER //
// src/views/courseware.vue